import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L, Show, TS_AppTools, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_ColorGroup } from '../ModuleFE_ColorGroup.js';
import './ATS_ColorGroupEditor.scss';
import { QScrollWrapper } from '@app/hcs-frontend';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { sortArray } from '@nu-art/ts-common';
export class ATS_ColorGroupEditor extends ComponentSync {
    // ######################### Static #########################
    static Screen = {
        key: 'color-group-editor',
        renderer: this,
        name: 'Color Group Editor',
        group: 'Editors',
        modulesToAwait: [ModuleFE_ColorGroup],
    };
    // ######################### Lifecycle #########################
    deriveStateFromProps(nextProps, state) {
        state.colorGroups = this.getColorGroups();
        if (!state.editable && state.colorGroups.length)
            state.editable = this.getEditable(state.colorGroups[0]);
        return state;
    }
    // ######################### Logic #########################
    getEditable(colorGroup) {
        return new EditableDBItemV3(colorGroup ?? {}, ModuleFE_ColorGroup)
            .setAutoSave(!!colorGroup?._id)
            .setOnChanged(async () => this.forceUpdate())
            .setOnSaveCompleted(colorGroup => {
            this.setState({
                colorGroups: this.getColorGroups(),
                editable: this.getEditable(colorGroup),
            });
        })
            .setOnDelete(async () => {
            const colorGroups = this.getColorGroups();
            this.setState({
                colorGroups,
                editable: this.getEditable(colorGroups[0]),
            });
        });
    }
    getColorGroups() {
        return sortArray(ModuleFE_ColorGroup.cache.allMutable(), colorGroup => colorGroup.label.toLowerCase());
    }
    // ######################### Render #########################
    render() {
        return _jsxs(_Fragment, { children: [TS_AppTools.renderPageHeader('Color Group Editor'), this.renderBody()] });
    }
    renderBody = () => {
        return _jsxs(LL_H_C, { className: 'color-group-editor', children: [this.render_List(), this.renderEditor()] });
    };
    // ######################### Render - List #########################
    render_List = () => {
        const editable = this.state.editable;
        return _jsxs(LL_V_L, { className: 'color-group-editor__list', children: [_jsx(QScrollWrapper, { children: this.state.colorGroups.map(colorGroup => {
                        const className = _className('color-group-editor__list__item', colorGroup._id === editable?.item._id && 'selected');
                        return _jsx("div", { className: className, onClick: () => {
                                this.setState({
                                    editable: this.getEditable(colorGroup),
                                });
                            }, children: colorGroup.label }, colorGroup._id);
                    }) }), _jsx("div", { className: 'color-group-editor__list__add-new', onClick: () => this.setState({ editable: this.getEditable() }), children: "Create New Color Group" })] });
    };
    // ######################### Render - Editor #########################
    renderEditor = () => {
        const editable = this.state.editable;
        if (!editable)
            return;
        return _jsxs(LL_V_L, { className: 'color-group-editor__editor', children: [_jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(DefaultEditor_InputText, { editable: editable, prop: 'label' }) }), this.renderEditor_Colors(editable), this.renderEditorButtons(editable)] });
    };
    renderEditor_Colors = (editable) => {
        const colors = editable.editProp('colors', []);
        const onValChange = (index, value) => colors.updateArrayAt(value, index);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Colors', children: _jsx(LL_H_C, { className: 'color-group-editor__colors', children: colors.item.map((color, index) => {
                    return _jsxs(LL_V_L, { className: 'color-group-editor__color', children: [_jsx("input", { type: 'color', value: color, onChange: e => onValChange(index, e.target.value) }), _jsx(TS_Input, { type: 'text', value: color, onBlur: val => onValChange(index, val) })] }, index);
                }) }) });
    };
    renderEditorButtons = (editable) => {
        return _jsx(LL_H_C, { className: 'color-group-editor__editor__buttons', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: !!editable?.item._id, children: _jsx(Button, { className: 'button_delete', onClick: async () => await editable.delete(), children: "Delete" }) }), _jsx(Show.If, { condition: !editable?.item._id, children: _jsx(Button, { className: 'button_save', onClick: async () => await editable.save(), children: "Save" }) })] }) });
    };
}
//# sourceMappingURL=ATS_ColorGroupEditor.js.map